import { Button, CalloutPlacement, EllipsisText } from 'canoe';
import { connectWithHammock, ENDPOINTS } from 'hammock';
import React from 'react';

import { useWorkspacePath } from 'commons/hooks';
import { SegmentDefinition } from 'dashboard/pages/Segment/components';
import { segmentPath } from 'dashboard/pages/Segment/constants';
import { segmentNamePlaceholder } from 'dashboard/pages/Segments/constants';

interface SegmentNameComponentProps {
  children: (attr: { name: string }) => React.ReactNode;
  segmentId: string;
  resource: SegmentDefinition;
}

const SegmentNameComponent = ({ children, resource }: SegmentNameComponentProps) => {
  return (
    <>
      {children({
        name: resource.name || segmentNamePlaceholder,
      })}
    </>
  );
};

const SegmentNameLoader = connectWithHammock(({ segmentId }) => ({
  endpoint: ENDPOINTS.segmentsDefinition,
  id: segmentId,
}))(SegmentNameComponent);

interface SegmentNameProps {
  linkToSegment?: boolean;
  segmentId?: string;
  tooltipPosition?: CalloutPlacement;
}

export const SegmentName = ({
  segmentId,
  linkToSegment,
  tooltipPosition = 'top',
}: SegmentNameProps) => {
  const workspacePath = useWorkspacePath();

  if (!segmentId || segmentId === 'Everyone') {
    return (
      <EllipsisText content="Everyone" placement={tooltipPosition}>
        <span>Everyone</span>
      </EllipsisText>
    );
  }

  return (
    <SegmentNameLoader linkToSegment={linkToSegment} segmentId={segmentId}>
      {({ name }: { name: string }) => (
        <>
          {linkToSegment ? (
            <Button
              appearance="text"
              variant="primary"
              onClick={(e) => {
                e.stopPropagation();
                window.open(workspacePath(segmentPath(segmentId)), `_blank`);
              }}
              inline
            >
              <EllipsisText content={name} placement={tooltipPosition}>
                <span style={{ display: 'block' }}>{name}</span>
              </EllipsisText>
            </Button>
          ) : (
            <EllipsisText content={name} placement={tooltipPosition}>
              <span style={{ display: 'block' }}>{name}</span>
            </EllipsisText>
          )}
        </>
      )}
    </SegmentNameLoader>
  );
};

export default SegmentName;
